var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 77.25C28.8684 77.25 19.1421 73.1972 11.8474 65.9024C4.55264 58.6077 0.5 48.8816 0.5 38.75C0.5 28.6184 4.55264 18.8923 11.8474 11.5976C19.1421 4.30283 28.8684 0.25 39 0.25C49.1316 0.25 58.8579 4.30283 66.1526 11.5976C73.4473 18.8923 77.5 28.6184 77.5 38.75C77.5 48.8816 73.4473 58.6077 66.1526 65.9024C58.8579 73.1972 49.1316 77.25 39 77.25ZM39 4.30263C19.9526 4.30263 4.55263 19.7026 4.55263 38.75C4.55263 57.7974 19.9526 73.1974 39 73.1974C58.0474 73.1974 73.4474 57.7974 73.4474 38.75C73.4474 19.7026 58.0474 4.30263 39 4.30263Z",
    fill: "#37D200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8927 54.9647C30.4874 54.9647 29.6769 54.9643 29.2716 54.5591L17.1138 42.4012C16.3032 41.5906 16.3032 40.375 17.1138 39.5645C17.9243 38.754 19.1401 38.754 19.9506 39.5645L30.4875 50.1018L57.2348 23.354C58.0453 22.5435 59.2611 22.5435 60.0716 23.354C60.8822 24.1645 60.8822 25.3801 60.0716 26.1906L31.7032 54.5591C32.1085 54.9643 31.298 54.9647 30.8927 54.9647Z",
    fill: "#37D200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5f20d12b.svg";
export { ForwardRef as ReactComponent };